export default "__VITE_ASSET__fs6W4aHZ__"